import { OrderItemRefundStatus, RefundStatus, RefundType } from "./enums.js";
const ExchangeStage = {
  /** 客户已提交，等客服审核 */
  PENDING_AUDIT: "pending_audit",
  /** 审核通过，等客户寄回 */
  PENDING_RETURN: "pending_return",
  /** 客户已寄回（填了单号），等客服确认收到 */
  PENDING_RECEIVE: "pending_receive",
  /** 客服已确认收到，等客服寄出换货件 */
  PENDING_SHIP: "pending_ship",
  /**
   * 换货件已寄出，**等客户确认收货**。
   *
   * ⚠️ 这一步以前被当成终态（"寄出即完成"）—— 用户 2026-09-30 指出流程不完整：
   *    「换货 寄出换货后 也需要客户确认收货」。寄出只是"我们发出去了"，
   *    客户有没有收到、收到的是不是对的，必须由客户确认才闭环。
   */
  SHIPPED: "shipped",
  /** ★ 客户已确认收到换货件 —— **售后单真正完成**（需求 2026-09-30） */
  RECEIVED: "received",
  /** 已驳回 */
  REJECTED: "rejected",
  /** 异常结束（渠道/人工标记失败） */
  FAILED: "failed"
};
const EXCHANGE_STAGE_TEXT = {
  [ExchangeStage.PENDING_AUDIT]: "\u5F85\u5BA2\u670D\u5BA1\u6838",
  [ExchangeStage.PENDING_RETURN]: "\u5F85\u5BA2\u6237\u5BC4\u56DE",
  [ExchangeStage.PENDING_RECEIVE]: "\u5F85\u5BA2\u670D\u786E\u8BA4\u6536\u8D27",
  [ExchangeStage.PENDING_SHIP]: "\u5F85\u5BC4\u51FA\u6362\u8D27",
  [ExchangeStage.SHIPPED]: "\u6362\u8D27\u5DF2\u53D1\u51FA\uFF08\u5F85\u5BA2\u6237\u786E\u8BA4\u6536\u8D27\uFF09",
  [ExchangeStage.RECEIVED]: "\u6362\u8D27\u5DF2\u5B8C\u6210",
  [ExchangeStage.REJECTED]: "\u5DF2\u9A73\u56DE",
  [ExchangeStage.FAILED]: "\u6362\u8D27\u5F02\u5E38"
};
const EXCHANGE_STAGE_HINT = {
  [ExchangeStage.PENDING_AUDIT]: {
    customer: "\u7533\u8BF7\u5DF2\u63D0\u4EA4\uFF0C\u5BA2\u670D\u4F1A\u5C3D\u5FEB\u5BA1\u6838",
    admin: "\u5BA2\u6237\u5DF2\u63D0\u4EA4\u6362\u8D27\u7533\u8BF7\uFF0C\u7B49\u5F85\u5BA1\u6838\uFF08\u540C\u610F\u540E\u5BA2\u6237\u624D\u80FD\u5BC4\u56DE\uFF09"
  },
  [ExchangeStage.PENDING_RETURN]: {
    customer: "\u8BF7\u628A\u5546\u54C1\u5BC4\u56DE\u5E76\u5728\u4E0B\u65B9\u586B\u5199\u5BC4\u56DE\u5FEB\u9012\u5355\u53F7",
    admin: "\u5DF2\u540C\u610F\u6362\u8D27\uFF0C\u7B49\u5F85\u5BA2\u6237\u5BC4\u56DE\uFF08\u5BA2\u6237\u586B\u5355\u53F7\u540E\u53EF\u786E\u8BA4\u6536\u8D27\uFF09"
  },
  [ExchangeStage.PENDING_RECEIVE]: {
    customer: "\u5DF2\u6536\u5230\u4F60\u7684\u5BC4\u56DE\u5355\u53F7\uFF0C\u5BA2\u670D\u786E\u8BA4\u6536\u8D27\u540E\u5C31\u4F1A\u5BC4\u51FA\u65B0\u4EF6",
    admin: "\u5BA2\u6237\u5DF2\u5BC4\u56DE\uFF0C\u8BF7\u6838\u5BF9\u5B9E\u7269\u540E\u70B9\u300C\u786E\u8BA4\u6536\u5230\u9000\u8D27\u300D"
  },
  [ExchangeStage.PENDING_SHIP]: {
    customer: "\u5BA2\u670D\u5DF2\u786E\u8BA4\u6536\u5230\u9000\u8D27\uFF0C\u6B63\u5728\u5B89\u6392\u5BC4\u51FA\u6362\u8D27\u4EF6",
    admin: "\u5DF2\u786E\u8BA4\u6536\u5230\u9000\u8D27\uFF0C\u8BF7\u5BC4\u51FA\u6362\u8D27\u4EF6\u5E76\u586B\u5199\u5FEB\u9012\u516C\u53F8\u4E0E\u5355\u53F7"
  },
  [ExchangeStage.SHIPPED]: {
    customer: "\u6362\u8D27\u4EF6\u5DF2\u5BC4\u51FA\uFF0C\u6536\u5230\u540E\u8BF7\u5728\u672C\u9875\u70B9\u300C\u786E\u8BA4\u6536\u5230\u6362\u8D27\u4EF6\u300D",
    admin: "\u6362\u8D27\u4EF6\u5DF2\u5BC4\u51FA\uFF0C\u7B49\u5F85\u5BA2\u6237\u786E\u8BA4\u6536\u8D27\uFF08\u5BA2\u6237\u786E\u8BA4\u540E\u552E\u540E\u5355\u624D\u5B8C\u6210\uFF09"
  },
  [ExchangeStage.RECEIVED]: {
    customer: "\u6362\u8D27\u5DF2\u5B8C\u6210\uFF0C\u611F\u8C22\u60A8\u7684\u8010\u5FC3\u7B49\u5F85",
    admin: "\u5BA2\u6237\u5DF2\u786E\u8BA4\u6536\u5230\u6362\u8D27\u4EF6\uFF0C\u552E\u540E\u5355\u5DF2\u5B8C\u6210"
  },
  [ExchangeStage.REJECTED]: {
    customer: "\u6362\u8D27\u7533\u8BF7\u672A\u901A\u8FC7\uFF0C\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u5BA2\u670D",
    admin: "\u6362\u8D27\u7533\u8BF7\u5DF2\u9A73\u56DE"
  },
  [ExchangeStage.FAILED]: {
    customer: "\u6362\u8D27\u5904\u7406\u5F02\u5E38\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
    admin: "\u6362\u8D27\u5904\u7406\u5F02\u5E38\uFF0C\u9700\u4EBA\u5DE5\u4ECB\u5165"
  }
};
function exchangeStageOf(input) {
  if (input.type !== RefundType.EXCHANGE)
    return null;
  const has = (v) => v !== null && v !== void 0 && String(v).trim() !== "";
  if (input.status === RefundStatus.REJECTED)
    return ExchangeStage.REJECTED;
  if (input.status === RefundStatus.FAILED)
    return ExchangeStage.FAILED;
  if (input.status === RefundStatus.SUCCESS) {
    return has(input.exchangeReceivedAt) ? ExchangeStage.RECEIVED : ExchangeStage.SHIPPED;
  }
  const audited = input.operatorId !== null && input.operatorId !== void 0 && Number(input.operatorId) > 0;
  if (has(input.returnReceivedAt))
    return ExchangeStage.PENDING_SHIP;
  if (has(input.returnExpressNo))
    return ExchangeStage.PENDING_RECEIVE;
  if (audited)
    return ExchangeStage.PENDING_RETURN;
  return ExchangeStage.PENDING_AUDIT;
}
function exchangeStageText(stage) {
  return EXCHANGE_STAGE_TEXT[stage];
}
function exchangeStageHint(stage, view) {
  return EXCHANGE_STAGE_HINT[stage][view];
}
const EXCHANGE_LOCK_ITEM_STATUS = OrderItemRefundStatus.PROCESSING;
const EXCHANGE_DONE_ITEM_STATUS = OrderItemRefundStatus.EXCHANGED;
const EXCHANGE_TEXT = {
  /** 类型说明（申请页） */
  TYPE_DESC: "\u540C\u6B3E\u540C\u89C4\u683C\u6362\u65B0 \xB7 \u4E0D\u9000\u4E0D\u8865",
  /** 申请页金额区的替代说明 */
  NO_MONEY: "\u6362\u8D27\u4E0D\u6D89\u53CA\u91D1\u989D\uFF1A\u65E0\u9700\u652F\u4ED8\uFF0C\u4E5F\u4E0D\u4F1A\u9000\u6B3E",
  /** 审核通过后给客户看的寄回说明 */
  RETURN_INSTRUCTION: "\u8BF7\u628A\u5546\u54C1\u6309\u539F\u5305\u88C5\u5BC4\u56DE\uFF0C\u5E76\u5728\u552E\u540E\u8BE6\u60C5\u91CC\u586B\u5199\u5BC4\u56DE\u5FEB\u9012\u516C\u53F8\u4E0E\u5355\u53F7\uFF1B\u5BA2\u670D\u786E\u8BA4\u6536\u5230\u540E\u6211\u4EEC\u4F1A\u7ACB\u5373\u5BC4\u51FA\u6362\u8D27\u4EF6\u3002"
};
const EXCHANGE_DEFAULT_COMPANY = "\u987A\u4E30\u901F\u8FD0";
export {
  EXCHANGE_DEFAULT_COMPANY,
  EXCHANGE_DONE_ITEM_STATUS,
  EXCHANGE_LOCK_ITEM_STATUS,
  EXCHANGE_STAGE_HINT,
  EXCHANGE_STAGE_TEXT,
  EXCHANGE_TEXT,
  ExchangeStage,
  exchangeStageHint,
  exchangeStageOf,
  exchangeStageText
};
